<div class="register-page">

    <header class="topbar">
        <a href="https://conectio.io/es/busco-trabajo" class="topbar-logo">
            <img src="/assets/conectio-logo.png" alt="Conectio · Unlocking Talent Acquisition" width="800" height="227">
        </a>
        <app-language-switcher></app-language-switcher>
    </header>

    <main class="hero">

        <!-- Pitch -->
        <section class="pitch">
            <p class="eyebrow">{{ (offer ? 'register.eyebrowOffer' : 'register.eyebrow') | translate }}</p>
            <h1>
                {{ 'register.title' | translate }}
                <span class="highlight">{{ 'register.titleHighlight' | translate }}</span>
            </h1>
            <p class="lead">{{ 'register.subtitle' | translate }}</p>

            <ul class="promises">
                <li>
                    <span class="promise-icon" aria-hidden="true">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>
                    </span>
                    <div>
                        <strong>{{ 'register.promises.answer.title' | translate }}</strong>
                        <span>{{ 'register.promises.answer.text' | translate }}</span>
                    </div>
                </li>
                <li>
                    <span class="promise-icon" aria-hidden="true">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
                    </span>
                    <div>
                        <strong>{{ 'register.promises.person.title' | translate }}</strong>
                        <span>{{ 'register.promises.person.text' | translate }}</span>
                    </div>
                </li>
                <li>
                    <span class="promise-icon" aria-hidden="true">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="6"/><circle cx="12" cy="12" r="2"/></svg>
                    </span>
                    <div>
                        <strong>{{ 'register.promises.fit.title' | translate }}</strong>
                        <span>{{ 'register.promises.fit.text' | translate }}</span>
                    </div>
                </li>
            </ul>
        </section>

        <!-- Form -->
        <section class="form-card" aria-labelledby="form-title">
            <h2 id="form-title" class="highlight">{{ 'register.formTitle' | translate }}</h2>
            <p class="form-subtitle" *ngIf="selectedPosition as position; else genericSubtitle"
               [innerHTML]="'register.formSubtitlePositionHtml' | translate: { title: position.title[language] }"></p>
            <ng-template #genericSubtitle>
                <p class="form-subtitle" [innerHTML]="(offer ? 'register.formSubtitleOfferHtml' : 'register.formSubtitleHtml') | translate"></p>
            </ng-template>

            <form [formGroup]="registerForm" (ngSubmit)="storeNameAndPhoneAndNavigate(true)" novalidate>

                <div class="field" [class.has-error]="registerForm.get('name')?.invalid && registerForm.get('name')?.touched">
                    <label for="name">{{ 'register.form.fullName' | translate }}</label>
                    <input id="name" type="text" formControlName="name" autocomplete="name"
                           [placeholder]="'register.form.fullNamePlaceholder' | translate">
                    <div class="field-error" *ngIf="registerForm.get('name')?.invalid && registerForm.get('name')?.touched">
                        {{ 'register.errors.nameRequired' | translate }}
                    </div>
                </div>

                <div class="field" [class.has-error]="(registerForm.get('phone')?.invalid && registerForm.get('phone')?.touched) || errorPhone">
                    <label for="phone">{{ 'register.form.phone' | translate }}</label>
                    <input id="phone" type="tel" formControlName="phone" autocomplete="tel" inputmode="tel"
                           [placeholder]="'register.form.phonePlaceholder' | translate">
                    <div class="field-error" *ngIf="registerForm.get('phone')?.invalid && registerForm.get('phone')?.touched">
                        {{ 'register.errors.phoneInvalid' | translate }}
                    </div>
                    <div class="field-hint">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
                        {{ 'register.descriptions.phoneStep' | translate }}
                    </div>
                </div>

                <label class="terms" [class.has-error]="registerForm.get('terms')?.invalid && registerForm.get('terms')?.touched">
                    <input type="checkbox" formControlName="terms">
                    <span>
                        {{ 'register.form.termsPrefix' | translate }}
                        <a href="https://conectio.io/terms-conditions" target="_blank" rel="noopener">{{ 'register.form.termsLink' | translate }}</a>
                        {{ 'register.form.termsAnd' | translate }}
                        <a href="https://conectio.io/privacy-policy" target="_blank" rel="noopener">{{ 'register.form.privacyLink' | translate }}</a>*
                    </span>
                </label>
                <div class="field-error" *ngIf="registerForm.get('terms')?.invalid && registerForm.get('terms')?.touched">
                    {{ 'register.errors.termsRequired' | translate }}
                </div>

                <button type="submit" class="btn-linkedin" [disabled]="isLoading">
                    <svg width="20" height="20" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                        <path d="M18.5 0.65625H1.5C1.10218 0.65625 0.720644 0.814285 0.43934 1.09559C0.158035 1.37689 0 1.75843 0 2.15625V19.1562C0 19.5541 0.158035 19.9356 0.43934 20.2169C0.720644 20.4982 1.10218 20.6562 1.5 20.6562H18.5C18.8978 20.6562 19.2794 20.4982 19.5607 20.2169C19.842 19.9356 20 19.5541 20 19.1562V2.15625C20 1.75843 19.842 1.37689 19.5607 1.09559C19.2794 0.814285 18.8978 0.65625 18.5 0.65625ZM6 17.6562H3V8.65625H6V17.6562ZM4.5 6.90625C4.15618 6.89642 3.82288 6.78549 3.54175 6.58733C3.26062 6.38916 3.04411 6.11254 2.9193 5.79203C2.79448 5.47152 2.76687 5.12133 2.83994 4.78522C2.913 4.44911 3.0835 4.14199 3.33011 3.90222C3.57673 3.66246 3.88853 3.50068 4.22656 3.43711C4.5646 3.37354 4.91387 3.411 5.23074 3.54479C5.5476 3.67859 5.81802 3.9028 6.00819 4.1894C6.19836 4.476 6.29986 4.81229 6.3 5.15625C6.2921 5.6266 6.09834 6.0747 5.76105 6.40262C5.42376 6.73053 4.97039 6.9116 4.5 6.90625ZM17 17.6562H14V12.9163C14 11.4963 13.4 10.9862 12.62 10.9862C12.3913 11.0015 12.1679 11.0617 11.9625 11.1636C11.7572 11.2654 11.574 11.4068 11.4235 11.5796C11.273 11.7524 11.1581 11.9533 11.0854 12.1707C11.0127 12.388 10.9837 12.6176 11 12.8462C10.995 12.8928 10.995 12.9397 11 12.9862V17.6562H8V8.65625H10.9V9.95625C11.1925 9.51125 11.5944 9.14882 12.0672 8.90369C12.54 8.65855 13.0677 8.53892 13.6 8.55625C15.15 8.55625 16.96 9.41625 16.96 12.2163L17 17.6562Z" fill="white"/>
                    </svg>
                    <span>{{ 'register.form.linkedinButton' | translate }}</span>
                    <span class="btn-badge">{{ 'register.form.linkedinBadge' | translate }}</span>
                </button>
                <p class="linkedin-reassure">{{ 'register.descriptions.linkedinDescription' | translate }}</p>

                <div class="formError server-error" *ngIf="errorPhone">{{ 'register.errors.phoneExists' | translate }}</div>

                <div class="divider"><span>{{ 'register.or' | translate }}</span></div>

                <button type="button" class="btn-manual" [disabled]="isLoading" (click)="storeNameAndPhoneAndNavigate(false)">
                    {{ 'register.form.manualButton' | translate }}
                </button>
            </form>

            <a class="help" href="https://wa.me/34644723402" target="_blank" rel="noopener">
                <img src="/assets/whatsapp.png" alt="" aria-hidden="true" width="18" height="18">
                <span>{{ 'register.help' | translate }}</span>
            </a>
        </section>
    </main>

    <!-- Open positions (published on the Conectio LinkedIn page) -->
    <section class="positions" aria-labelledby="positions-title">
        <div class="positions-header">
            <h2 id="positions-title" class="positions-title">
                {{ 'register.positions.title' | translate }}
                <b>{{ 'register.positions.titleHighlight' | translate }}</b>
            </h2>
            <p class="positions-subtitle">{{ 'register.positions.subtitle' | translate }}</p>
        </div>

        <ul class="positions-grid">
            <ng-container *ngFor="let position of positions; let i = index">
                <li *ngIf="showAllPositions || i < visiblePositions">
                    <a class="position-card" [class.selected]="position.id === offer"
                       routerLink="/session/register" [queryParams]="{ offer: position.id }" queryParamsHandling="merge"
                       (click)="scrollToForm()">
                        <div class="position-tags" *ngIf="isNewPosition(position) || position.id === offer">
                            <span class="position-tag position-tag--new" *ngIf="isNewPosition(position)">{{ 'register.positions.new' | translate }}</span>
                            <span class="position-tag position-tag--selected" *ngIf="position.id === offer">{{ 'register.positions.selected' | translate }}</span>
                        </div>
                        <h3 class="position-name">{{ position.title[language] }}</h3>
                        <p class="position-meta">{{ position.sector[language] }}</p>
                        <p class="position-meta position-meta--location" *ngIf="position.location">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>
                            {{ position.location[language] }}
                        </p>
                        <span class="position-cta">{{ 'register.positions.apply' | translate }} <span aria-hidden="true">→</span></span>
                    </a>
                </li>
            </ng-container>
        </ul>

        <div class="positions-footer">
            <button type="button" class="positions-more" *ngIf="positions.length > visiblePositions"
                    [attr.aria-expanded]="showAllPositions" (click)="showAllPositions = !showAllPositions">
                {{ (showAllPositions ? 'register.positions.showLess' : 'register.positions.showMore') | translate: { count: positions.length } }}
            </button>
            <a class="positions-linkedin" href="https://www.linkedin.com/company/conectiodigital/" target="_blank" rel="noopener">
                {{ 'register.positions.linkedin' | translate }} <span aria-hidden="true">↗</span>
            </a>
        </div>
    </section>

    <!-- How it works + numbers -->
    <section class="how">
        <div class="how-inner">
            <div class="steps">
                <h2 class="eyebrow eyebrow-light">{{ 'register.how.eyebrow' | translate }}</h2>
                <ol>
                    <li>
                        <span class="step-num">1</span>
                        <div><strong>{{ 'register.how.step1.title' | translate }}</strong><span>{{ 'register.how.step1.text' | translate }}</span></div>
                    </li>
                    <li>
                        <span class="step-num">2</span>
                        <div><strong>{{ 'register.how.step2.title' | translate }}</strong><span>{{ 'register.how.step2.text' | translate }}</span></div>
                    </li>
                    <li>
                        <span class="step-num">3</span>
                        <div><strong>{{ 'register.how.step3.title' | translate }}</strong><span>{{ 'register.how.step3.text' | translate }}</span></div>
                    </li>
                </ol>
            </div>
            <dl class="stats">
                <div><dt>100%</dt><dd>{{ 'register.stats.answer' | translate }}</dd></div>
                <div><dt>x2</dt><dd>{{ 'register.stats.chances' | translate }}</dd></div>
                <div><dt>98%</dt><dd>{{ 'register.stats.satisfied' | translate }}</dd></div>
            </dl>
        </div>
    </section>

    <!-- Social proof -->
    <section class="proof">
        <h2 class="proof-title">
            {{ 'register.proof.title' | translate }}
            <b>{{ 'register.proof.titleHighlight' | translate }}</b>
        </h2>
        <div class="proof-grid">
            <a class="proof-card" href="https://www.lavanguardia.com/empresas-de-vanguardia/historias-de-exito/20260518/11526734/ia-encuentra-candidato-ideal-primera-entrevista-reduce-60-seleccion.html" target="_blank" rel="noopener">
                <div class="proof-media proof-media--top">
                    <img src="/assets/proof/la-vanguardia.jpg" width="798" height="1100" [alt]="'register.proof.pressAlt' | translate" loading="lazy">
                </div>
                <div class="proof-body">
                    <span class="proof-source">La Vanguardia</span>
                    <p class="proof-quote">{{ 'register.proof.press' | translate }}</p>
                    <span class="proof-link">{{ 'register.proof.pressLink' | translate }} <span aria-hidden="true">↗</span></span>
                </div>
            </a>
            <a class="proof-card" href="https://talentarena.tech/es/ponentes/?e-filter-e709af0-tipo=xpro-pass" target="_blank" rel="noopener">
                <div class="proof-media">
                    <img src="/assets/proof/talent-arena.jpg" width="828" height="551" [alt]="'register.proof.eventAlt' | translate" loading="lazy">
                </div>
                <div class="proof-body">
                    <span class="proof-source">Talent Arena · Mobile World Capital Barcelona</span>
                    <p class="proof-quote">{{ 'register.proof.event' | translate }}</p>
                    <span class="proof-link">{{ 'register.proof.eventLink' | translate }} <span aria-hidden="true">↗</span></span>
                </div>
            </a>
            <a class="proof-card" href="https://choosemycompany.com/es/clasificaciones/2025/at-work?regionCode=ES&size=1-24" target="_blank" rel="noopener">
                <div class="proof-media proof-media--badge">
                    <img src="/assets/proof/choosemycompany-certificate.png" width="445" height="560" [alt]="'register.proof.awardAlt' | translate" loading="lazy">
                </div>
                <div class="proof-body">
                    <span class="proof-source">ChooseMyCompany · HappyIndex®AtWork 2025</span>
                    <p class="proof-quote">{{ 'register.proof.award' | translate }}</p>
                    <img class="proof-award-strip" src="/assets/proof/choosemycompany-2nd.png" width="500" height="80" alt="" aria-hidden="true" loading="lazy">
                    <span class="proof-link">{{ 'register.proof.awardLink' | translate }} <span aria-hidden="true">↗</span></span>
                </div>
            </a>
        </div>
    </section>
</div>

<app-footer></app-footer>
